// import Tooltip from '@mui/material/Tooltip';
import React from 'react';
import { useState } from 'react';

interface Props {
  color?: string;
}

const TwitterIcon = ({ color }: Props) => {
  const [color1, setColor] = useState('#A8B2D1');

  return (
    <>
      {/* <Tooltip
        title="Twitter"
        placement="right-start"
      > */}
      <svg
        width="24"
        height="20"
        viewBox="0 0 24 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        onMouseEnter={() => setColor('#64FFDA')}
        onMouseLeave={() => setColor('#A8B2D1')}
      >
        <path
          d="M21.8912 1.6525C22.127 1.65447 22.3578 1.72089 22.5585 1.84459C22.7592 1.96829 22.9223 2.14454 23.0301 2.35426C23.1378 2.56399 23.1862 2.79919 23.1699 3.03442C23.1535 3.26964 23.0732 3.49592 22.9375 3.68875L21.635 5.54C21.555 11.8975 19.4287 16.2137 15.315 18.37C13.3547 19.3442 11.1887 19.8325 8.99999 19.7937C6.29358 19.856 3.61915 19.1986 1.24999 17.8888C1.09062 17.7816 0.967443 17.6287 0.896705 17.4502C0.825967 17.2717 0.810988 17.076 0.853742 16.8888C0.893768 16.6988 0.990458 16.5254 1.13105 16.3915C1.27165 16.2576 1.44953 16.1695 1.64124 16.1387C3.2328 15.9165 4.80005 15.5457 6.32249 15.0312C-0.500008 11.875 0.987492 4.78 1.63749 2.60125C1.70086 2.38494 1.82001 2.18911 1.98298 2.03341C2.14595 1.8777 2.34701 1.7676 2.56598 1.71416C2.78495 1.66071 3.01412 1.6658 3.2305 1.72892C3.44688 1.79204 3.64285 1.91096 3.79874 2.07375C5.79579 4.13153 8.44365 5.43449 11.2925 5.76125C11.2419 4.99567 11.3603 4.22834 11.6391 3.51357C11.918 2.7988 12.3506 2.15406 12.9062 1.625C13.8689 0.711458 15.1467 0.204249 16.4738 0.208906C17.8009 0.213562 19.0751 0.729725 20.0312 1.65L21.8912 1.6525ZM2.65124 17.2425C4.97874 18.3325 10.4337 19.5162 14.735 17.2625C18.4287 15.3262 20.33 11.3475 20.3862 5.43625C20.3888 5.24079 20.4507 5.05071 20.5637 4.89125L21.915 2.96875L21.8637 2.9025C21.2162 2.89375 20.5775 2.885 19.9262 2.9025C19.6723 2.89668 19.4292 2.79846 19.2425 2.62625C18.5229 1.89686 17.546 1.47884 16.5215 1.46201C15.4971 1.44518 14.5069 1.83089 13.7637 2.53625C13.2864 2.99021 12.9297 3.55586 12.7256 4.18217C12.5216 4.80849 12.4767 5.47575 12.595 6.12375C12.6168 6.24447 12.6107 6.36855 12.5774 6.48659C12.544 6.60463 12.4842 6.71352 12.4025 6.805C12.3242 6.89728 12.2244 6.9689 12.112 7.01359C11.9995 7.05827 11.8778 7.07463 11.7575 7.06125C8.39901 6.82688 5.24549 5.36008 2.90249 2.9425C2.06499 5.54 1.00249 11.81 7.73874 14.2737C7.88051 14.3246 8.00478 14.4149 8.09691 14.5341C8.18904 14.6532 8.24519 14.7962 8.25874 14.9462C8.27399 15.094 8.24681 15.243 8.18039 15.3758C8.11397 15.5087 8.01107 15.6198 7.88374 15.6962C6.23766 16.499 4.46924 17.0215 2.65124 17.2425Z"
          fill={color || color1}
        />
      </svg>
      {/* </Tooltip> */}
    </>
  );
};

export default TwitterIcon;
